export default __webpack_public_path__ + "static/media/animal-32.dd4496ad.svg";